<template>
  <wrap-container>
    <div :class="emprCuenta ? 'empr-cuenta' : 'icons-box'">
      <div class="icon-with-text" v-for="award in awards" :key="award.label">
        <div class="img-container">
          <img
            :class="`icon${awards.indexOf(award)}`"
            :src="
              require(`@/assets/img/ofertaNomina/cajaDeAhorro/${award.icon}`)
            "
            alt="Ícono paquete de beneficios"
          />
        </div>
        <p class="icon-text" v-safe-html="award.label" />
      </div>
    </div>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";

const campania = _BBVA_MOTOR || "ofertaNomina";

export default {
  name: "PremiosOfertaCajaAhorro",
  components: {
    WrapContainer
  },
  props: {
    emprCuenta: Boolean
  },
  data() {
    return {
      awards: require(`@/config/brands/${campania}.js`).premios
    };
  }
};
</script>

<style scoped>
.icons-box {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  align-items: flex-start;
  margin-bottom: 50px;
}

.icon-with-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 30%;
}

img {
  width: 70%;
}

.img-container {
  width: 92px;
  height: 92px;
  background-color: #e6e6e6;
  border-radius: 50%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.icon-text {
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: center;
  color: #666666;
  margin-top: 16px;
}

@media screen and (max-width: 599px) {
  .icons-box {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  }

  .empr-cuenta .icon-with-text {
    width: auto;
  }

  .icon-with-text {
    width: 70%;
    height: 100%;
  }
  .empr-cuenta .img-container {
    width: 90px;
  }

  .img-container {
    width: 60px;
    height: 60px;
    margin: 0 auto;
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
  img {
    width: 70%;
  }
  .icon-text {
    font-size: 12px;
    margin: 8px auto 0;
    text-align: center;
  }
  .middle-iwt {
    margin-left: 0px;
    margin-right: 0px;
  }
  .card-container {
    margin: 0 auto;
    text-align: center;
  }
  .card {
    min-width: 149px;
    min-height: 94px;
  }
  .margin-benefits-m {
    margin-top: 32px;
  }

  .button-mobile {
    display: block;
    margin-bottom: 60px;
    margin-top: -25px;
  }
}
@media screen and (min-width: 601px) and (max-width: 1024px) {
  .icon-text {
    width: auto;
    font-size: 12px;
    margin: 8px auto 0;
    text-align: center;
  }
  .middle-iwt {
    margin-left: 0px;
    margin-right: 0px;
  }
  .icons-box {
    display: flex;
    align-items: center;
    flex-direction: row;
  }
  .icon-with-text {
    width: 33%;
    height: 100%;
  }
  .img-container {
    width: 80px;
    height: 80px;
    margin: 0 auto;
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
  img {
    width: 70%;
  }
}
</style>
